// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { MarketplaceHealthCommands } from '../../../../types/server/modules/marketplaceHealth/commands';

export type * from '../../../../types/server/modules/marketplaceHealth/commands';

export const createCommands = ( requests: Requests ): MarketplaceHealthCommands => ({
  SyncSellerReputation: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/seller-reputation/:id/sync-seller-reputation`, { id, ...query, body }, headers );
  }, { operation: 'marketplace-health:sync-seller-reputation', route: 'POST /seller-reputation/:id/sync-seller-reputation', subdomain: 'marketplace-health', visibility: 'private' } as const ),
  SyncListingVisits: Object.assign(({ id, query, body }, headers ) => {
    return requests.post( `/listing-visits/:id/sync-listing-visits`, { id, ...query, body }, headers );
  }, { operation: 'marketplace-health:sync-listing-visits', route: 'POST /listing-visits/:id/sync-listing-visits', subdomain: 'marketplace-health', visibility: 'private' } as const )
});
